import { useQuery } from '@tanstack/react-query';
import { ClientProfileResponse } from 'happypaws-shared/src/User/models/ClientProfileResponse';
import { api } from '../../services/api';

export const useClientProfile = () => {
  return useQuery({
    queryKey: ['clientProfile'],
    queryFn: async () => {
      const response = await api.get<ClientProfileResponse>('/clients/profile');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
